import { z } from 'zod';
import { AssetLifecycleSchema } from './generated/modelSchema/AssetLifecycleSchema';
import { SignalSchema } from './generated/modelSchema/SignalSchema';
import { EndpointCandidateSchema } from './generated/modelSchema/EndpointCandidateSchema';

const OptionalAssetLifecycleCreateInputSchema = AssetLifecycleSchema.partial();

const SignalCreateRequiredFieldsSchema = SignalSchema.pick({
  targetType: true,
  category: true,
  targetId: true,
});

export const SignalCreateInputSchema = SignalCreateRequiredFieldsSchema.and(
  SignalSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    targetType: true,
    category: true,
    targetId: true,
  })
    .partial()
    .extend({
      lifecycle: OptionalAssetLifecycleCreateInputSchema.optional(),
    }),
);

export const SignalUncheckedCreateInputSchema =
  SignalCreateRequiredFieldsSchema.and(
    SignalSchema.omit({
      targetType: true,
      category: true,
      targetId: true,
    })
      .partial()
      .extend({
        lifecycle: OptionalAssetLifecycleCreateInputSchema.optional(),
      }),
  );

export type SignalUncheckedCreateInput = z.infer<
  typeof SignalUncheckedCreateInputSchema
>;

export const HarNameValueCreateInputSchema = z.object({
  name: z.string(),
  value: z.string(),
});

export const HarPostDataParamCreateInputSchema = z.object({
  name: z.string(),
  value: z.string().nullable().optional(),
  contentType: z.string().nullable().optional(),
});

export const HarPostDataCreateInputSchema = z.object({
  mimeType: z.string().nullable().optional(),
  text: z.string().nullable().optional(),
  params: z.array(HarPostDataParamCreateInputSchema).nullable().optional(),
});

export const EndpointCandidateCreateInputSchema = EndpointCandidateSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})
  .extend({
    headers: z.array(HarNameValueCreateInputSchema),
    queryString: z.array(HarNameValueCreateInputSchema),
    postData: HarPostDataCreateInputSchema.nullable().optional(),
  })
  .partial({
    tenantId: true,
    credentialIds: true,
    uri: true,
    apiType: true,
    graphqlOperationName: true,
    soapOperationName: true,
    xmlOperationName: true,
    mcpOperationName: true,
    grpcServiceName: true,
    grpcMethodName: true,
    sourceDetail: true,
    endpointId: true,
    webpageId: true,
    httpVersion: true,
    headersSize: true,
    bodySize: true,
    requiresHumanVerification: true,
    verificationStatus: true,
    failureReason: true,
    metadata: true,
  });
